export interface NewsScoreRange {
  min: number;
  max: number;
  score: number;
}

export const newsScoreRanges = {
  // Respiration rate (per minute)
  med_breaths: [
    { min: -Infinity, max: 8, score: 3 },
    { min: 9, max: 11, score: 1 },
    { min: 12, max: 20, score: 0 },
    { min: 21, max: 24, score: 2 },
    { min: 25, max: Infinity, score: 3 },
  ] as NewsScoreRange[],

  // SPO2 Scale 2 (%) - for patients on oxygen
  med_sp02: [
    { min: -Infinity, max: 83, score: 3 },
    { min: 84, max: 85, score: 2 },
    { min: 86, max: 87, score: 1 },
    { min: 88, max: 92, score: 0 },
    { min: 93, max: 94, score: 1 },
    { min: 95, max: 96, score: 2 },
    { min: 97, max: Infinity, score: 3 },
  ] as NewsScoreRange[],

  // Systolic blood pressure (mmHg)
  med_pressure_sys: [
    { min: -Infinity, max: 90, score: 3 },
    { min: 91, max: 100, score: 2 },
    { min: 101, max: 110, score: 1 },
    { min: 111, max: 219, score: 0 },
    { min: 220, max: Infinity, score: 3 },
  ] as NewsScoreRange[],

  // Pulse (per minute)
  med_pulse: [
    { min: -Infinity, max: 40, score: 3 },
    { min: 41, max: 50, score: 1 },
    { min: 51, max: 90, score: 0 },
    { min: 91, max: 110, score: 1 },
    { min: 111, max: 130, score: 2 },
    { min: 131, max: Infinity, score: 3 },
  ] as NewsScoreRange[],

  // Temperature (°C)
  med_temperature: [
    { min: -Infinity, max: 35.0, score: 3 },
    { min: 35.1, max: 36.0, score: 1 },
    { min: 36.1, max: 38.0, score: 0 },
    { min: 38.1, max: 39.0, score: 1 },
    { min: 39.1, max: Infinity, score: 2 },
  ] as NewsScoreRange[],
};

const colorScoreMap = {
  0: "#fdfffe",
  1: "#fff2a9",
  2: "#f5c486",
  3: "#ea9178",
};

export const getNewsScore = (
  tag: string,
  value: number | string,
): { score: number; color: string } => {
  const numValue = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(numValue)) {
    return { score: 3, color: colorScoreMap[3] };
  }

  const ranges = newsScoreRanges[tag as keyof typeof newsScoreRanges];
  if (!ranges) {
    return { score: 0, color: colorScoreMap[0] };
  }

  for (const range of ranges) {
    if (numValue >= range.min && numValue <= range.max) {
      return {
        score: range.score,
        color: colorScoreMap[range.score as keyof typeof colorScoreMap],
      };
    }
  }

  return { score: 0, color: colorScoreMap[0] };
};

export const getBloodPressureNewsScore = (
  systolic: number | string,
): { score: number; color: string } => {
  return getNewsScore("med_pressure_sys", systolic);
};
